<!--
 * @Author: lixiaodi
 * @Date: 2020-03-13 09:14:59
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-03-16 17:32:39
 -->
 <template>
        <div class="box-sty inner">
            <!-- 摄影 -->
            <div>
                <pic-sheyin-list></pic-sheyin-list>
            </div>

<!--插图-->
          <div>
            <pic-chatu-list></pic-chatu-list>
          </div>

    </div>
</template>

<script>
import PicSheyinList from './picSheyinList'
import PicChatuList from './picChatuList'
export default {
  name: 'PicShareOne',
  data() {
    return {
    }
  },
  components: {
    PicSheyinList,
    PicChatuList
  }
}
</script>
<style lang="stylus" scoped>
.teacher-title{
    height: 1.2rem;
    background: url('../../../../assets/images/index_k6tbg.jpg') center no-repeat;
    text-align: center
    line-height: 1.2rem;
    font-size: 0.42rem;
    font-weight: bold;
    color: #228457;
}
.box-sty{
    margin-bottom .1rem
    padding-bottom .1rem
    border-bottom 1px solid #efefef
    display flex
    flex-direction row
    justify-content space-between
}
.box-sty > div {
    width: 49.5%
    background rgba(0,176,135,0.2);
    height 4rem
    overflow hidden
}
</style>



// WEBPACK FOOTER //
// src/components/Education/components/index/picShareOne.vue